"use client";

// True for every page in the `(marketing)` route group: `MarketingProviders`
// sets it, nothing else does. The shared `<Header>` reads it to show the
// public nav and, instead of the avatar menu, the "Log in / Get started"
// pair — swapped for a single "Dashboard" button once a session resolves —
// so a visitor sees the same header on `/`, `/pricing` and `/blog`. Pages
// outside the group that also render `<Header>` (clip-download, admin) keep
// the session-aware avatar.

import { createContext, useContext } from "react";

export const MarketingPageContext = createContext(false);

export const useIsMarketingPage = () => useContext(MarketingPageContext);
